<p>create-product-configuration works!</p>
<!--crateconfiguration-->
<div>
  <!--OuterFrame-->
  <app-outer-frame-product-configuration></app-outer-frame-product-configuration>
</div>
